import { TEXTOS } from '../../../lib/glossario'

/**
 * As colunas da tabela e o que cada uma esconde em tela estreita.
 *
 * A classe de visibilidade mora aqui, e não solta em cada `<th>` e `<td>`, porque cabeçalho e
 * célula têm de sumir JUNTOS: esconder só um desloca a tabela inteira dali para a direita, e o
 * defeito só aparece na largura exata em que a regra vale — ninguém vê isso revisando no desktop.
 */

/**
 * O que a lista está mostrando, dito uma vez só.
 *
 * Vira a `<caption>` da tabela e o nome da lista de cartões do celular — as duas formas da mesma
 * página de resultados. Quem usa leitor de tela ouve isto antes do primeiro registro.
 */
export const DESCRICAO_DA_LISTA = TEXTOS.chamados.descricaoDaLista

export interface Coluna {
  /** Identificador estável. Não é rótulo: renomear o cabeçalho não pode trocar a chave. */
  id: string
  titulo: string
  /** Classe de visibilidade, quando a coluna some em tela estreita. */
  classe?: string
}

/** Some abaixo de `md`. Abertura é contexto: o que decide fiscalização é o fechamento. */
export const SO_A_PARTIR_DE_MEDIA = 'hidden md:table-cell'

/**
 * Some abaixo de `xl`.
 *
 * Entidade, grupo e procedência continuam no cartão do celular e no detalhe — escondê-los aqui tira
 * ruído sem tirar informação de lugar nenhum. A procedência é a única que dói esconder, e por isso
 * o carimbo no topo da tela a repete em toda largura: ele não some nunca.
 *
 * Era `lg`, e o ponto de corte mente: a partir de `lg` o menu lateral fixo come 272px, e a tabela de
 * nove colunas cortava a última numa tela de 1440px. O ponto conta a janela, não o espaço que sobra.
 */
export const SO_A_PARTIR_DE_LARGA = 'hidden xl:table-cell'

/** Some abaixo de `2xl`: o que só cabe com folga — o grupo atendente e a procedência. */
export const SO_EM_TELA_MUITO_LARGA = 'hidden 2xl:table-cell'

export const COLUNAS: Coluna[] = [
  { id: 'chamado', titulo: 'Chamado' },
  { id: 'assunto', titulo: 'Assunto' },
  { id: 'entidade', titulo: 'Entidade', classe: SO_A_PARTIR_DE_LARGA },
  { id: 'grupo', titulo: 'Grupo atendente', classe: SO_EM_TELA_MUITO_LARGA },
  { id: 'prazo', titulo: 'Prazo' },
  { id: 'aberto', titulo: 'Aberto em', classe: SO_A_PARTIR_DE_MEDIA },
  { id: 'fechado', titulo: 'Fechado em' },
  // Fica ao lado do fechamento, e NÃO some em tela estreita (o cartão do celular também a traz):
  // "este chamado já foi julgado?" é a pergunta que decide se o fiscal precisa abri-lo, e responder
  // isso é o trabalho inteiro de fechar um mês com 107 chamados.
  { id: 'julgamento', titulo: TEXTOS.chamados.colunaDoJulgamento },
  { id: 'procedencia', titulo: 'De onde veio', classe: SO_EM_TELA_MUITO_LARGA },
]
